import React, { useState } from "react";
import { Modal, ModalBody, ModalTitle, ModalFooter } from "@vds/modals";
import { useTranslation } from "react-i18next";

export const LQWidgetModal = ({opened=false,onOpenedChange=()=>{},handleQualification = ()=>{}})=>{
    const [eventReceived,setEventReceived] = useState('')
    const [eventReceivedEffect, setEventReceivedEffect] = useState(undefined)
      const { t } = useTranslation(["gridwall"]);

    React.useEffect(()=>{
            const scriptE = document.createElement("script")
            scriptE.src = "https://www.verizon.com/foryoursmallbiz/lqwidget/business-lq-widget.js"
            scriptE.defer = true
            scriptE.async = true
            document.body.appendChild(scriptE)
        }, [])
        React.useEffect(()=>{
            if(eventReceived && eventReceived !== eventReceivedEffect){
                setEventReceivedEffect(eventReceived)
                handleQualification(eventReceived)
            }
        },[eventReceived])
    window.addEventListener("continueClicked",(e)=>{
        if(e?.detail && e?.detail?.selectedFlow) {
            setEventReceived(val=>{
                if(val !== e?.detail?.selectedFlow) return e?.detail?.selectedFlow
            })
        }
    },{once:true})
    return(
        <Modal opened={opened} onOpenedChange={onOpenedChange}>
            <ModalTitle>{t("gridwall.lqWidgetTitle", { ns: "gridwall" })}</ModalTitle>
            <ModalBody>
            <internet-lq-widget type="form" fromprospectqualification="true" fromuc="true"> </internet-lq-widget>
            </ModalBody>
        </Modal>
    )
}